var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('el-image',{staticStyle:{"width":"100%","height":"100%"},attrs:{"preview-src-list":_vm.option.attribute.preview ? [_vm.option.attribute.url]:[],"src":_vm.option.attribute.url?_vm.fileUrl+_vm.option.attribute.url:require('@/assets/logo.png'),"fit":_vm.option.attribute.fit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }